export const SKINS = {
  standard: 'standard',
  success: 'success',
  error: 'error',
  urgent: 'urgent',
} as const;

export const SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;
